<template>
    <div class="kefu" v-if="$parent.company.config.openOnline === 1" :class="{out:showClass}">
        <div class="pack-up cp color-blue" @click="closeOpen" v-if="!showClass">
            <span class="iconfont icon-ziyuan"></span>
            收起
        </div>
        <div class="pack-down cp color-blue" @click="closeOpen" v-if="showClass">
            <span class="iconfont icon-ziyuan dib"></span>展开
        </div>
        <ul>
            <li v-if="$parent.company.config.onlineInfo.onlineTel != ''">
                <span class="zhu ac">
                    <i class="icons kf-phone"></i>
                    电话
                </span>
                <div class="fu">电话：{{$parent.company.config.onlineInfo.onlineTel}}</div>
            </li>
            <li v-if="$parent.company.config.onlineInfo.onlineQq != ''">
                <span class="zhu ac">
                    <i class="icons kf-qq"></i>
                    QQ
                </span>
                <div class="fu">QQ：{{$parent.company.config.onlineInfo.onlineQq}}</div>
            </li>
            <li v-if="$parent.company.config.onlineInfo.onlineWx != ''">
                <span class="zhu ac">
                    <i class="icons kf-wx"></i>
                    微信
                </span>
                <div class="fu wx">
                    <img class="img" :src="$parent.company.config.onlineInfo.onlineWx" alt="">
                    <span class="db mt10">{{$parent.company.config.onlineInfo.nickName}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "kefu",
    props: {},
    data() {
        return {
            showClass:false
        }
    },
    mounted() {
       let customService = sessionStorage.getItem('customService');
       if(customService){
           this.showClass = JSON.parse(customService);
       }
    },
    created() {
		
    },
    methods: {
        closeOpen (){
            this.showClass = !this.showClass;
            sessionStorage.setItem('customService',JSON.stringify(this.showClass));
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/components/kefu.vue